import React from "react";
import {Button, Grid} from "@mui/material";

import TechnicalSpecificationItem from "./TechnicalSpecificationItem";

// Types
import {
    InlineTechnicalSpecificationType,
    TechnicalSpecificationItemType
} from "../../../types/inlineTechnicalSpecificationsType";

// Styling
import {Plus} from "react-feather";



const InlineTechnicalSpecifications: React.FC<InlineTechnicalSpecificationType> = (props) => {
    const {onUpdate, onAdd, onDelete, types, multiEdit} = props;

    // Trigger element update
    const onUpdateHandler = (data: any) => {
        onUpdate(data);
    }

    // Trigger element delete
    const onDeleteHandler = (data: TechnicalSpecificationItemType) => {
        onDelete(data.id);
    }

    const addElement = () => {
        const newElement = {
            id: new Date().getTime().toString(),
            type: '',
            sorting: '',
            options: []
        }
        onAdd(newElement);
    }


    return (
        <React.Fragment>
            <Grid container spacing={6}>
                {props.items.length > 0 &&
                    <Grid item xs={12}>
                        {props.items.map((item: TechnicalSpecificationItemType) => {
                            return (
                                <TechnicalSpecificationItem
                                    key={item.id}
                                    item={item}
                                    types={types}
                                    onUpdate={onUpdateHandler}
                                    onDelete={onDeleteHandler}
                                    multiEdit={multiEdit}
                                />
                            )
                        })}
                    </Grid>
                }
                <Grid item xs={12} mb={5}>
                    <Button variant="contained" component="span" startIcon={<Plus/>} onClick={addElement}>Add specification</Button>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default InlineTechnicalSpecifications;
